import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import { config } from './config';

/**
 * Auth only.
 *
 * The app this replaces called `Amplify.configure` three times — in index.js, in
 * App.js, and again in x5client.js to register a REST endpoint — and pulled in
 * the API, GraphQL and DataStore categories with it. Cognito is the only Amplify
 * category left: `aws-amplify` is now just the Cognito SDK, and nothing here
 * depends on Amplify tooling, hosting, or a generated config file.
 */
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.userPoolId,
      userPoolClientId: config.userPoolClientId,
    },
  },
});

/**
 * The ID token, which is what the API Gateway JWT authorizer validates against
 * the pool. Its `cognito:username` claim is what the API uses as the AppStream
 * UserId, so the browser never sends a username of its own.
 */
export async function getIdToken(): Promise<string | null> {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() ?? null;
  } catch {
    return null;
  }
}
